// Mount point for the Underwriting section (#36368).
const Underwriting = () => null;

export default Underwriting;
